import { useContext, useEffect, useMemo } from "react";
import { StudentToofiContext } from "@/context/student-toofi-context";
import type { StudentToofiSurfaceRegistration } from "@/types/student-toofi";

export function useStudentToofi() {
  const context = useContext(StudentToofiContext);
  if (context === undefined) {
    throw new Error("useStudentToofi must be used within a StudentToofiProvider");
  }
  return context;
}

export function useStudentToofiPageContext(context: StudentToofiSurfaceRegistration | null) {
  const { setSurfaceRegistration } = useStudentToofi();
  const metadataKey = useMemo(() => JSON.stringify(context?.metadata ?? null), [context?.metadata]);
  const normalizedContext = useMemo<StudentToofiSurfaceRegistration | null>(() => {
    if (!context) return null;
    return {
      title: context.title,
      subtitle: context.subtitle,
      linkedResourceId: context.linkedResourceId,
      linkedPlanId: context.linkedPlanId,
      metadata: context.metadata,
    };
  }, [context?.title, context?.subtitle, context?.linkedResourceId, context?.linkedPlanId, metadataKey]);

  useEffect(() => {
    setSurfaceRegistration(normalizedContext);
  }, [normalizedContext, setSurfaceRegistration]);

  useEffect(
    () => () => {
      setSurfaceRegistration(null);
    },
    [setSurfaceRegistration],
  );
}
